module.exports = __webpack_public_path__ + "static/img/icon4.bd263593.png";